import { FunctionComponent, useCallback } from "react";
import { CircularProgress } from "@material-ui/core";
import { RouteProps } from "react-router-dom";
import { useAuthRedirect } from "./useAuthRedirect";

interface IAuthenticatedRouteProps extends RouteProps {
    /**Child component to display */
    Component?: FunctionComponent<any>;
    /**Used to pass props to the child component */
    childComponentProps?: any;
    LoadingComponent?: FunctionComponent<any>
}

/**
 * Authenticates Routes using Cognito context 
 * Once a user is authenticated will display child component
 */
const AuthenticatedRoute = ({ Component, childComponentProps, LoadingComponent, children }: IAuthenticatedRouteProps) => {
    
    const { isAuthenticated }  = useAuthRedirect();
    const render =useCallback(() => {
            return isAuthenticated === true ?
                !Component ? <>{children}</> :
                    <Component {...childComponentProps}>
                        {children}
                    </Component>
                : <Loader LoadingComponent={LoadingComponent} />;
    // eslint-disable-next-line            
    },[isAuthenticated])
    return render();
};

function Loader({ LoadingComponent }: { LoadingComponent?: FunctionComponent<any> }) {
    return (
        LoadingComponent ? <LoadingComponent /> : <CircularProgress className="padded-centre" />
    )
}


export default AuthenticatedRoute;